// Actuele post-ideeën met echte bronnen (juni 2026).
// Update deze lijst als de markt verandert of nieuwe onderwerpen relevant worden.

export const TOPIC_IDEAS = [
  {
    id: "scam-2026-tiktok-ai",
    emoji: "⚠️",
    accent: "danger",
    title: "Scam-piek 2026: hoe oplichters met AI en TikTok huurwoningen namaken",
    topic:
      "De grote piek in huurwoning-scams van zomer 2026 in Nederland: hoe oplichters foto's stelen van legitieme verhuurders (Gruno, DC Wonen, Lefier), AI-gegenereerde teksten gebruiken, en woningzoekers met koffers voor een dichte deur laten staan. Concrete red flags, waarom studenten en expats de grootste risicogroep zijn, en de checklist die WoningAlert al automatisch toepast.",
    tags: ["scam", "veiligheid", "actueel"],
    city: "",
    target_length_words: 950,
    source_urls: [
      "https://www.rtvnoord.nl/economie/1424350/piek-in-nepadvertenties-voor-huurwoningen-mensen-stonden-met-koffers-voor-een-dichte-deur",
      "https://nos.nl/artikel/2624811-nepadvertenties-voor-huurwoningen-pieken-in-de-zomer-met-koffers-voor-dichte-deur",
      "https://opgelicht.avrotros.nl/nieuws/pas-op-voor-nepverhuurders-oplichters-lokken-woningzoekers-met-nepadvertenties-20452",
      "https://www.woonbond.nl/nieuws/nieuwe-malafide-verhuursites-blijven-opduiken/",
    ],
  },
  {
    id: "wet-betaalbare-huur-2026",
    emoji: "📜",
    accent: "brand",
    title: "Wet Betaalbare Huur: wat betekenen 187 punten voor jouw huurcontract?",
    topic:
      "Uitleg van de Wet betaalbare huur (van kracht sinds 1 juli 2024), het puntensysteem tot 186 punten, wanneer je huurverlaging kunt eisen, hoe gemeenten sinds januari 2025 handhaven en boetes uitdelen, en de maximale huurverhoging voor middenhuur van 6,1% in 2026. Praktische stappen voor huurders die vermoeden dat ze te veel betalen, en de rol van de Huurcommissie.",
    tags: ["huren", "wetgeving", "puntensysteem"],
    city: "",
    target_length_words: 1100,
    source_urls: [
      "https://www.volkshuisvestingnederland.nl/wat-betekent-de-wet-betaalbare-huur-voor-mij/info/over-de-wet-betaalbare-huur",
      "https://aedes.nl/huurbeleid-en-betaalbaarheid/wet-betaalbare-huur-van-kracht-sinds-1-juli-wat-er-anders",
      "https://www.rijksoverheid.nl/vraag-en-antwoord/woning-huren/hoeveel-huur-betaal-ik-maximaal-voor-mijn-woning",
    ],
  },
  {
    id: "koopmarkt-Q2-2026",
    emoji: "📈",
    accent: "success",
    title: "Koopmarkt Q2 2026: eindelijk lucht voor kopers?",
    topic:
      "Het tweede kwartaal 2026 laat de zesde opeenvolgende afname zien in de groei van woningprijzen. Recordaanbod (56.700 woningen te koop, +9% j-o-j), gemiddelde prijs €506k, en de uitpondgolf van huurwoningen die het aanbod stuwt. Wat betekent dit voor starters, waar zit nog echte prijsdruk (Amsterdam stabiliseert, Oost-Groningen stijgt), en hoe je onderhandelingsruimte herkent.",
    tags: ["kopen", "marktanalyse", "starters"],
    city: "",
    target_length_words: 1000,
    source_urls: [
      "https://www.nvm.nl/nieuws/2026/nvm-recordaantal-woningen-te-koop-gezet-in-tweede-kwartaal-verkoop-blijft-sterk/",
      "https://www.rabobank.nl/kennis/d011529617-kwartaalbericht-woningmarkt-einde-van-de-prijsrally-huizenmarkt-koelt-af",
      "https://monitor-koopwoningmarkt.nl/wp-content/uploads/2026/06/Kwartaalrapportage-Monitor-Koopwoningmarkt-2026-1.pdf",
    ],
  },
  {
    id: "expat-guide-amsterdam-2026",
    emoji: "🌍",
    accent: "brand",
    title: "Expat-huurgids Amsterdam 2026: van 4 weken zoeken naar sneller een woning",
    topic:
      "Praktische gids voor expats en internationals die in 2026 een huurwoning zoeken in Amsterdam of Rotterdam. Waarom sociale huur geen optie is (wachttijden 5-15 jaar), typische huurprijzen (Amsterdam €1.500-2.500 voor 1-slaapkamer, Rotterdam €1.100-1.700), welke documenten je klaar moet hebben (paspoort, contract, 3 loonstroken), 30% ruling, en het BRP inschrijvingsproces binnen 5 dagen na tekenen. Waarom automated alerts en snel reageren onmisbaar zijn.",
    tags: ["expats", "amsterdam", "rotterdam", "huren"],
    city: "Amsterdam",
    target_length_words: 1200,
    source_urls: [
      "https://dutchpat.com/renting-in-the-netherlands/",
      "https://expatnetherlandshub.com/guides/housing/finding-housing-netherlands-expats-2026/",
      "https://bright-apartments.com/en/blog/renting-in-amsterdam-expat-guide-2026/",
    ],
  },
  {
    id: "sociale-huur-wachttijd-2026",
    emoji: "⏳",
    accent: "warning",
    title: "Sociale huur in 2026: 7+ jaar wachten en 2,2% slaagkans, hoe overleef je dat?",
    topic:
      "De sociale huurmarkt in cijfers: in Delft ruim 7 jaar wachten, slaagkans 2,2%. Waarom nieuwbouw acht jaar duurt en wat het Actieplan Versnelling Woningbouw van september 2026 belooft (halvering doorlooptijd tegen 2030). Inkomensgrenzen 2026 (€51.537 alleenstaand / €56.910 huishouden), de 15% vrije toewijzing, urgentieverklaring, en waarom particuliere huur voor de meesten het enige realistische alternatief is. Concrete stappen om je kansen te maximaliseren.",
    tags: ["sociale-huur", "wachttijd", "starters"],
    city: "",
    target_length_words: 1050,
    source_urls: [
      "https://www.rijksoverheid.nl/vraag-en-antwoord/huurwoning-zoeken/wanneer-kom-ik-in-aanmerking-voor-een-sociale-huurwoning",
      "https://www.omroepdelft.nl/delft/wachttijd-voor-sociale-huurwoning-in-delft-opgelopen-tot-ruim-zeven-jaar-slaagkans-22-procent/",
      "https://www.rijksoverheid.nl/actueel/nieuws/2026/09/21/kabinet-pakt-woningnood-aan-met-50-concrete-acties-sneller-meer-en-beter-bouwen",
    ],
  },
];
